/* eslint-disable no-underscore-dangle */
/* eslint-disable no-console */
import { ApolloClient, InMemoryCache, ApolloLink } from '@apollo/client';
import { LABELS } from '@app/config';
import { errorLink, httpLink, authLink } from './links';
import sharedTypePolicies from '../shared/sharedTypePolicies';

const client = () =>
  new ApolloClient({
    link: ApolloLink.from([errorLink, authLink, httpLink]),
    cache: new InMemoryCache({
      typePolicies: sharedTypePolicies,
    }),
    name: LABELS.APP_HUMAN_NAME,
    version: LABELS.APP_HUMAN_VERSION,
  });

export default client;
